/* WO-757 A3: each pickup response belongs to one selected variant.
   Keep the retry template even when the initial variant is unavailable. */
(function () {
  "use strict";
  if (customElements.get("pickup-availability")) return;

  customElements.define("pickup-availability", class extends HTMLElement {
    constructor() {
      super();
      const errorTemplate = this.querySelector("template");
      this.errorHtml = errorTemplate && errorTemplate.content.firstElementChild
        ? errorTemplate.content.firstElementChild.cloneNode(true)
        : null;
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.requestId = 0;
      this.requestController = null;
      this.pickupDrawer = null;
    }

    connectedCallback() {
      if (this.hasAttribute("available")) this.fetchAvailability(this.dataset.variantId);
    }

    disconnectedCallback() {
      this.cancelRequest();
      this.removeDrawer();
    }

    cancelRequest() {
      this.requestId += 1;
      if (this.requestController) this.requestController.abort();
      this.requestController = null;
    }

    removeDrawer() {
      if (this.pickupDrawer) this.pickupDrawer.remove();
      this.pickupDrawer = null;
    }

    async fetchAvailability(variantId) {
      if (!variantId) return;
      this.cancelRequest();
      this.dataset.variantId = String(variantId);
      const requestId = this.requestId;
      const selectedVariantId = this.dataset.variantId;
      const controller = new AbortController();
      this.requestController = controller;
      this.removeDrawer();
      this.removeAttribute("available");
      this.innerHTML = "";
      const isCurrent = () => this.isConnected && requestId === this.requestId && selectedVariantId === this.dataset.variantId;
      const rootUrl = this.dataset.rootUrl || "/";
      const root = rootUrl.endsWith("/") ? rootUrl : rootUrl + "/";

      try {
        const response = await fetch(root + "variants/" + encodeURIComponent(selectedVariantId) + "/?section_id=api-pickup-availability", { signal: controller.signal });
        if (!response.ok) throw new Error("Pickup response failed");
        const html = await response.text();
        if (!isCurrent()) return;
        const section = new DOMParser().parseFromString(html, "text/html").querySelector(".shopify-section");
        if (!section) throw new Error("Pickup response markup missing");
        this.renderPreview(section);
      } catch (error) {
        if (error.name !== "AbortError" && isCurrent()) this.renderError();
      } finally {
        if (isCurrent()) this.requestController = null;
      }
    }

    onClickRefreshList() {
      this.fetchAvailability(this.dataset.variantId);
    }

    update(variant) {
      this.cancelRequest();
      this.removeDrawer();
      this.removeAttribute("available");
      this.innerHTML = "";
      if (variant && variant.id) this.dataset.variantId = String(variant.id);
      else delete this.dataset.variantId;
      if (variant && variant.available) this.fetchAvailability(variant.id);
    }

    renderError() {
      this.removeDrawer();
      this.removeAttribute("available");
      this.innerHTML = "";
      if (!this.errorHtml) return;
      this.appendChild(this.errorHtml.cloneNode(true));
      const button = this.querySelector("button");
      if (button) button.addEventListener("click", this.onClickRefreshList);
    }

    renderPreview(section) {
      const preview = section.querySelector("pickup-availability-preview");
      if (!preview) {
        this.innerHTML = "";
        this.removeAttribute("available");
        this.removeDrawer();
        return;
      }
      const drawer = section.querySelector("pickup-availability-drawer");
      if (!drawer) throw new Error("Pickup drawer markup missing");

      const previousDrawer = document.querySelector("pickup-availability-drawer");
      if (previousDrawer) previousDrawer.remove();
      this.innerHTML = preview.outerHTML;
      this.setAttribute("available", "");
      this.pickupDrawer = drawer;
      (this.dataset.productPageColorScheme || "").split(/\s+/).filter(Boolean).forEach(color => drawer.classList.add(color));
      document.body.appendChild(drawer);

      const button = this.querySelector("button");
      if (button) button.addEventListener("click", () => {
        if (!drawer.isConnected || this.pickupDrawer !== drawer) return;
        const popup = drawer.querySelector("popup-component");
        if (popup && typeof popup.popupOpen === "function") popup.popupOpen();
      });
    }
  });
})();
